var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioOffBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "radioOffBlackTitle"
  }, "Radio Off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "radioOffBlackTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-225.000000, -542.000000)",
    stroke: "#B3B3B3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 548,
    r: 5.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOffBlack);
export default __webpack_public_path__ + "static/media/Radio_off_black.59358eecea9bc9489f235d45eaefdf15.svg";
export { ForwardRef as ReactComponent };